import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useT } from '../i18n';
import { usePageMeta } from '../seo';

/**
 * Neznámá adresa.
 *
 * Do teď sem chodil katalog: překlep v odkazu, smazaný produkt i cizí spamová
 * adresa vrátily plnohodnotnou stránku se zbožím. Návštěvník má dojem, že
 * odkaz funguje, a Google to zná jako „soft 404" – stránku, která tvrdí, že
 * existuje, i když ne. Takových adres si všimne a sníží důvěru celému webu.
 *
 * Než se ukáže hláška, zkusí se přesměrování: když zboží jen změnilo adresu,
 * patří návštěvník na tu novou, ne na omluvu.
 */
export function NotFoundPage() {
  const { t } = useT();
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  usePageMeta({
    title: `${t('notFound.title')} | Super Krmivo`,
    description: t('notFound.text'),
    // Neexistující adresa do indexu nepatří. Skutečný stav 404 umí jenom
    // server (apps/api/src/routes/seo.ts); tohle je nejvíc, co zvládne
    // stránka vykreslená až v prohlížeči.
    index: false,
  });

  useEffect(() => {
    let live = true;
    setChecking(true);

    void api.redirectFor(location.pathname + location.search).then((target) => {
      if (!live) return;
      if (target === null) {
        setChecking(false);
        return;
      }
      // `replace`, ne nová položka v historii: zpětné tlačítko má vrátit tam,
      // odkud návštěvník přišel, ne zpátky na mrtvou adresu.
      void navigate(target, { replace: true });
    });

    return () => {
      live = false;
    };
  }, [location.pathname, location.search, navigate]);

  if (checking) return <p className="muted">{t('notFound.checking')}</p>;

  return (
    <>
      <h1>{t('notFound.title')}</h1>
      <p className="muted">{t('notFound.text')}</p>
      <p>
        <Link className="link" to="/">
          {t('cart.backToShop')}
        </Link>
      </p>
    </>
  );
}
